import { Button, Card, Col, Flex, Row, Space } from "antd";
import { useTranslation } from "react-i18next";

const CompanyAppearance = ({
    changeTheme = () => { },
    onCancel = () => { },
    themeColor = [],
    onSubmit = () => { },
    resetTheme = () => { },
    currentTheme = "",
    isDisabled = "",
    permissions
}) => {
    const { t, i18n } = useTranslation();

    return (
        <div style={{ display: "flex", flexDirection: "column", minHeight: "65vh" }}>
            <Space direction="vertical" size={48} style={{
                flex: 1, width: "100%",
                display: "flex",
                flexDirection: "column",
                // opacity: !permissions?.UPDATE ? 0 : 0.9,
                pointerEvents: !permissions?.UPDATE ? "none" : "all",
            }}>
                <Flex justify="space-between">
                    <Flex vertical>
                        <h3>{t("appearance.label.theme")}</h3>
                        <span style={{ fontSize: "14px" }}>{t("appearance.label.choose_theme")}</span>
                    </Flex>
                    <Button
                        style={{ height: "44px", borderRadius: "8px", backgroundColor: "#FAEAEB", borderColor: "#F1620F", color: "#F1620F" }}
                        onClick={resetTheme}
                    >
                        {t("appearance.label.reset")}
                    </Button>
                </Flex>
                <Flex vertical

                >
                    <Row style={{ justifyContent: "center" }}>
                        {themeColor.map((theme) => (
                            <Col span={4} key={theme.code}>
                                <Card
                                    onClick={() => changeTheme(theme)}
                                    style={{ width: "165px", borderRadius: "30px", border: "1px solid " + (currentTheme == theme.code ? "black" : "#EAECF0"), backgroundColor: "#FCFCFC", cursor: "pointer" }}
                                    styles={{ body: { padding: "5px" } }}
                                >
                                    <Flex>
                                        <Col span={7}>
                                            <div style={{ backgroundColor: theme.color.buttonBG, borderRadius: "50%", width: "40px", height: "40px" }} />
                                        </Col>
                                        <Col span={17} style={{ alignContent: "center", textAlignLast: "center" }}>
                                            <span style={{ color: "#414E62" }}>{i18n.language == "en" ? theme.nameEn : theme.name}</span>
                                        </Col>
                                    </Flex>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Flex>
            </Space>

            <Row justify="end" style={{ position: "sticky", bottom: 0, padding: "16px 0" }}>
                {/* <Button style={{ height: "44px", borderRadius: "8px" }}>{t("appearance.label.preview")}</Button> */}

                <Flex gap={12}>
                    <Button style={{ height: "44px", borderRadius: "8px" }} disabled={isDisabled} onClick={onCancel}>{t("common.cancel")}</Button>
                    <Button type="primary"
                        onClick={onSubmit}
                        disabled={!permissions.UPDATE || isDisabled}
                        style={{
                            height: "44px",
                            borderRadius: "8px",
                            backgroundColor: !permissions.UPDATE || isDisabled ? "" : "var(--button-color)",
                            color: !permissions.UPDATE || isDisabled ? "" : "var(--button-text-color)"
                        }}
                    >
                        {t("common.save_change")}
                    </Button>
                </Flex>
            </Row>
        </div>
    )
}

export default CompanyAppearance;